import { ReducerRegistry } from '../base/redux';

import {
    MATERIAL_LIST_CLOSE,
    MATERIAL_LIST_OPEN
} from './actionTypes';
import { REDUCER_KEY } from './constants';

const DEFAULT_STATE = {
    isOpen: false
}

ReducerRegistry.register(
    REDUCER_KEY, (state = DEFAULT_STATE, action) => {
        switch (action.type) {
        case MATERIAL_LIST_CLOSE:
            return {
                ...state,
                isOpen: false
            };

        case MATERIAL_LIST_OPEN:
            return {
                ...state,
                isOpen: true
            };

        default:
            return state;
        }
    }
);
